import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { PermissionEnum } from '@core/enums/permission.enum';
import { CoreStore } from '@core/store/core.store';
import { userRetrieved$ } from '@core/store/core-store.utils';

export const sessionUserPermissionsResolver: ResolveFn<PermissionEnum[]> = (route, state) => {
  const coreStore = inject(CoreStore);

  return userRetrieved$().pipe(
    map(() => coreStore.userPermissions())
  );
};
